import Header from "./Header"
import "../Myprojects.css"
import Overview from "./Overview"
import Resources from "./Resources"
import Feedback from "./Feedback"
import Submission from "./Submission"
import Details from "./Details"
import React, { useState,useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import api from "views/auth/Api";
import { API_BASE_URL } from '../../../../configs/AppConfig';


const ProjectMain = () => {
      const [data , setData] = useState([]);
      const [current , setCurrent] = useState("overview");
      const [title , setTitle] = useState("");
      const [subject , setSubject] = useState("");
      const [team , setTeam] = useState("");

      const { id } = useParams();
      const navigate = useNavigate();

       useEffect(() => {
       api.get(`${API_BASE_URL}assigned-projects/${id}`)
        .then((response) => {  
          if (!response.data) {
            navigate(`/auth/not-found/`);
          }
          setData(response.data);
          setTitle(response.data?.project?.project?.projectName);
          setSubject(response.data?.project?.project?.subject);
          setTeam(response.data?.name);
        })
        .catch((error) => {
          console.error('Error fetching card:', error);
        });
    }, [navigate,id]);
  


  const change = (page) => {
          setCurrent(page);
        }
  const res =(newData) => {
   setData(newData);
  }
  return (
    <div>
      <Header current = {current} change ={change} title={title} subject={subject} team={team} />
     {current ==="overview" ? <Overview data={data} /> : null }
     {current ==="details" ? <Details data={data} /> : null }
     {current ==="resources" ? <Resources data={data} /> : null }
     {current ==="model3d" ? <Submission data={data} res={res}/> : null }
     {current ==="subFeed" ? <Feedback data={data}/> : null }
    </div>
  );
};

export default ProjectMain;
